import { observer } from 'mobx-react'
import React from 'react'
import { Calendar } from '../../Components/Calendar/Calendar'

export default observer(() => (
    <div style={{ width: '80em' }}>
        <Calendar mode="allocation" />
    </div>
))
